import { I18n } from '@boschebike/ebds-js';
import { SyntheticEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { InternalEventLink } from '../../../components';
import { useContent } from '../../../hooks/use-content';
import { setModalSheetProps } from '../../../store/slices/modalSheet.slice';

export const ServiceThemeEditorAnnexOnePage = () => {
  const dispatch = useDispatch();

  const content: I18n = useContent();

  const contentKeyPage: string = content.t('portal.termsOfUse.manufacturerServices.themeEditor.annex1');
  const contentKeyCloseModalText: string = content.t('portal.termsOfUse.manufacturerServices.themeEditor.annex.closeModalText');
  const contentKeyOpenModalText: string = content.t('portal.termsOfUse.manufacturerServices.themeEditor.annex.openModalText');

  const onOpenAnnex = useCallback(
    (e: SyntheticEvent<HTMLButtonElement>) => {
      e.preventDefault();

      dispatch(
        setModalSheetProps({
          payload: {
            content: contentKeyPage,
            actionLabelCancel: contentKeyCloseModalText,
          },
          type: 'annex',
        }),
      );
    },
    [contentKeyPage, contentKeyCloseModalText],
  );

  return (
    <InternalEventLink
      onClickEvent={onOpenAnnex}
      text={contentKeyOpenModalText}
    />
  );
};
